import './helpers/publicPath';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { hydrate } from 'react-dom';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import dotenv from 'dotenv';

/* eslint-disable */
// We need to load the config before anything else.

import {
  __DEBUG__,
  APP_ENV,
  saveConstants,
  SENTRY_DSN,
} from './config/constants'
/* eslint-enable */

import * as serviceWorker from './serviceWorker';
import App from './containers/App';

dotenv.config();

// Don't log env for production
if (__DEBUG__) {
  if (APP_ENV) {
    console.log(`Running environment ${APP_ENV}`);
  }
  console.log(process.env);
}

if (!__DEBUG__) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    attachStacktrace: true,
    environment: APP_ENV,
    tracesSampleRate: 1.0,
  });
}

function renderApp(options: AppOptions) {
  const container = (typeof options.element === 'string' ? document.querySelector(options.element) : options.element) as HTMLElement;

  const { logInPageMessage } = container.dataset;

  saveConstants({
    ...options,
    logInPageMessage,
  });

  const render = () => {
    const reactElement = (
      <App />
    );

    if (window.Cypress || (container && container.innerHTML !== '')) {
      hydrate(reactElement, container);
    } else {
      const root = createRoot(container);
      root.render(reactElement);
    }
  };

  render();

  if (module.hot) {
    module.hot.accept('./', () => {
      render();
    });
  }
}

renderApp({
  element: '#root',
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
